const AlertType = {
    ContentType: 1,
    UserGenerated: 2,
    FlowStateChange: 3,
    FlowStateExpired: 4
}
export default AlertType
